import { render, staticRenderFns } from "./EventNewContext.vue?vue&type=template&id=c3bd6a24&scoped=true"
import script from "./EventNewContext.vue?vue&type=script&lang=js"
export * from "./EventNewContext.vue?vue&type=script&lang=js"
import style0 from "./EventNewContext.vue?vue&type=style&index=0&id=c3bd6a24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bd6a24",
  null
  
)

export default component.exports